'use client';

import Lottie from 'lottie-react';
import spinnerAnimation from './spinner.json';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  /**
   * ローディングコンテキスト
   * - global: グローバルローディング（min-h-screen、背景色あり）
   * - dashboard: ダッシュボード内ローディング（flex-1、パディングあり）
   * - inline: インラインローディング（コンテナなし）
   */
  context?: 'global' | 'dashboard' | 'inline';
}

export default function LoadingSpinner({
  size = 'md',
  message,
  context = 'inline',
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
  };

  const content = (
    <div className="flex flex-col items-center justify-center gap-4 py-8">
      <div className={sizeClasses[size]}>
        <Lottie animationData={spinnerAnimation} loop={true} />
      </div>
      {message && <p className="text-mono-70 text-sm">{message}</p>}
    </div>
  );

  if (context === 'global') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-mono-5">
        {content}
      </div>
    );
  }

  if (context === 'dashboard') {
    return (
      <div className="flex-1 flex items-center justify-center p-4 md:p-8">
        {content}
      </div>
    );
  }

  // inline context
  return content;
}
